__turbopack_context__.v({
  "className": "caveat_800f3616-module__J2999a__className",
});
